var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBitwarden(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21698_199317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7334 13.2714C32.5547 13.0895 32.3431 13 32.1013 13H15.8986C15.654 13 15.4452 13.0895 15.2666 13.2714C15.0879 13.4533 15 13.6688 15 13.915V24.915C15 25.735 15.1566 26.5492 15.4699 27.3579C15.7832 28.1639 16.1734 28.8802 16.6379 29.507C17.1023 30.131 17.6546 30.7411 18.2977 31.3343C18.9408 31.9275 19.5343 32.4172 20.0757 32.809C20.6198 33.2007 21.1859 33.5701 21.7768 33.9199C22.3676 34.2697 22.7881 34.5047 23.0354 34.6278C23.2827 34.7509 23.4833 34.8489 23.6317 34.9132C23.7444 34.9692 23.8653 35 23.9972 35C24.1291 35 24.25 34.972 24.3627 34.9132C24.5139 34.8461 24.7117 34.7509 24.9618 34.6278C25.2092 34.5047 25.6296 34.2668 26.2204 33.9199C26.8113 33.5701 27.3774 33.2007 27.9215 32.809C28.4656 32.4172 29.0592 31.9247 29.7022 31.3343C30.3453 30.7411 30.8977 30.1338 31.3621 29.507C31.8265 28.8802 32.214 28.1666 32.53 27.3579C32.8433 26.552 32.9999 25.7377 32.9999 24.915V13.9178C33.0027 13.6688 32.912 13.4533 32.7334 13.2714ZM30.6449 25.0186C30.6449 29.0006 24 32.4311 24 32.4311V15.3561H30.6449C30.6449 15.3561 30.6449 21.0366 30.6449 25.0186Z",
    fill: "#175DDC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21698_199317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 22,
    fill: "white",
    transform: "translate(15 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitwarden);
export default __webpack_public_path__ + "static/media/Bitwarden.36772c5376e615f14c7c1d04b3b967d1.svg";
export { ForwardRef as ReactComponent };